import { successColor } from './status/success';
export const success = (mode)=>{
    const color = successColor(mode);
    return {
        main: color.main,
        light: mode === 'light' ? color.lowContrast : color.highContrast,
        dark: mode === 'light' ? color.highContrast : color.lowContrast
    };
};

//# sourceMappingURL=success.js.map